import * as React from 'react'
import { FC, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { toast } from '@sales-center/components'
import { useSelector } from 'react-redux'
import {
  selectUserAuthenticated,
  setRedirectUrl,
} from '@user/store/authorization/userSlice'
import { notAuthenticated } from '@user/store/authorization/permissions'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'

type Props = {
  isAllowed?: boolean
  children?: React.ReactElement
}

export const ProtectedRouteWithToast: FC<Props> = ({ isAllowed, children }) => {
  const authenticated = useSelector(selectUserAuthenticated)
  const allowAccess = authenticated && isAllowed

  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { pathname, search } = useLocation()

  useEffect(() => {
    if (authenticated) {
      if (!allowAccess) {
        navigate('/access-denied')
      }
    } else {
      toast.info(notAuthenticated)
      if (search) {
        dispatch(setRedirectUrl(pathname + search))
      } else {
        dispatch(setRedirectUrl(pathname))
      }
      navigate('/')
    }
  }, [allowAccess, authenticated, dispatch, navigate, search, pathname])

  return allowAccess ? <>{children}</> : null
}
ProtectedRouteWithToast.displayName = 'ProtectedRouteWithToast'
